var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "price-outdate" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "main_blck" }, [
          _c("div", { staticClass: "img  p-center" }, [
            _c("img", {
              attrs: { src: require("../../../img/01-clock.svg"), alt: "" }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "text  p-center" }, [
            _c("p", { staticClass: "p-title relawayBold p-black" }, [
              _vm._v("Sorry, price outdated...")
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "Raleway p-center min-med" }, [
              _vm._v("You need to update the search result to proceed")
            ]),
            _vm._v(" "),
            _c("button", { staticClass: "btn btn-green" }, [
              _vm._v("Update search results")
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }